import script from "./AddPermissionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPermissionForm.vue?vue&type=script&setup=true&lang=js"

import "./AddPermissionForm.vue?vue&type=style&index=0&id=cca9dc16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca9dc16"]])

export default __exports__